export default {
    // Activity
    DATA_LOADING: 'data-loading',
    DATA_ERROR: 'data-error',
    DISMISS_DATA_ERROR: 'dismiss-data-error',
    SET_MODAL_ERROR: 'set-modal-error',
    SET_MODAL_STATUS: 'set-modal-status',
    // All stops
    FETCH_STOPS: 'fetch-stops',
    // All routes
    FETCH_ROUTES: 'fetch-routes',
    // All agencies
    POPULATE_AGENCIES: 'populate-agencies',
    // All vehicles
    FETCH_VEHICLES_REALTIME: 'fetch-vehicles-realtime',
    FETCH_TRIP_UPDATES_REALTIME: 'fetch-trip-updates-realtime',
    MERGE_VEHICLE_FILTERS: 'merge-vehicle-filters',
    // Search
    SEARCH_LOADING: 'addresses-loading',
    UPDATE_SEARCH_TERMS: 'update-search-terms',
    UPDATE_ADDRESS_SEARCH_RESULTS: 'update-address-search-results',
    UPDATE_STOP_SEARCH_RESULTS: 'update-stop-search-results',
    UPDATE_ROUTE_SEARCH_RESULTS: 'update-route-search-results',
    UPDATE_STOP_GROUP_SEARCH_RESULTS: 'update-stop-group-search-results',
    UPDATE_STOP_GROUP_MERGED_SEARCH_RESULTS: 'update-stop-group-merged-search-results',
    UPDATE_STOP_MESSAGE_SEARCH_RESULTS: 'update-stop-message-search-results',
    UPDATE_STOP_DISRUPTION_SEARCH_RESULTS: 'update-stop-disruption-search-results',
    UPDATE_STOP_IN_GROUP_SEARCH_RESULTS: 'update-stop-in-group-search-results',
    UPDATE_STOP_MESSAGES_SORTING_PARAMS: 'update-stop-messages-sorting-params',
    CLEAR_SEARCH_RESULTS: 'clear-search-results',
    UPDATE_SEARCH_BAR_FOCUS: 'update-search-bar-focus',
    UPDATE_SELECTED_SEARCH_RESULTS_CHECK_STATUS: 'update-selected-search-result-check-status',
    UPDATE_VIEW_DETAIL_KEY: 'update-view-detail-key',
    ADD_SELECTED_SEARCH_RESULT: 'add-selected-search-result',
    REMOVE_SELECTED_SEARCH_RESULT: 'remove-selected-search-result',
    CLEAR_SELECTED_SEARCH_RESULT: 'clear-selected-search-result',

    // Detail
    CLEAR_DETAIL: 'clear-detail',
    DISPLAY_REAL_TIME_DETAIL: 'display-real-time-detail',
    UPDATE_SELECTED_VEHICLE: 'update-selected-vehicle',
    UPDATE_SELECTED_ADDRESS: 'update-selected-address',
    UPDATE_SELECTED_STOP: 'update-selected-stop',
    UPDATE_SELECTED_ROUTE: 'update-selected-route',
    // Stop detail
    FETCH_STOP_INFO: 'fetch-stop-info',
    FETCH_STOP_UPCOMING_VEHICLES: 'fetch-stop-upcoming-vehicles',
    FETCH_STOP_PAST_VEHICLES: 'fetch-stop-past-vehicles',
    FETCH_STOP_ROUTES: 'fetch-stop-routes',
    FETCH_STOP_PID_MESSAGES: 'fetch-stop-pid-messages',
    FETCH_STOP_PID_INFORMATION: 'fetch-stop-pid-information',
    FETCH_STOP_ROUTES_STOPS: 'fetch-stop-routes-stops',
    FETCH_STOP_DISRUPTIONS: 'fetch-stop-disruptions',
    UPDATE_STOP_VEHICLE_PREDICATE: 'update-stop-vehicle-predicate',
    // Route detail
    FETCH_ROUTE_INFO: 'fetch-route-info',
    FETCH_ROUTE_TRIPS: 'fetch-route-trips',
    FETCH_ROUTE_STOPS: 'fetch-route-stops',
    UPDATE_ROUTE_VEHICLE_PREDICATE: 'update-route-vehicle-predicate',
    // Fleet
    FETCH_TRAINS_FROM_FLEET: 'fetch-trains-from-fleet',
    FETCH_BUSES_FROM_FLEET: 'fetch-buses-from-fleet',
    FETCH_FERRIES_FROM_FLEET: 'fetch-ferries-from-fleet',
    // Vehicle detail
    FETCH_VEHICLE_INFO: 'fetch-vehicle-info',
    FETCH_VEHICLE_FLEET_INFO: 'fetch-vehicle-fleet-info',
    FETCH_VEHICLE_UPCOMING_STOPS: 'fetch-vehicle-upcoming-stops',
    FETCH_VEHICLE_PAST_STOPS: 'fetch-vehicle-past-stops',
    FETCH_TRIP: 'fetch-trip',
    FETCH_VEHICLE_TRIP_STOPS: 'fetch-vehicle-trip-stops',
    UPDATE_VEHICLE_VEHICLE_PREDICATE: 'update-vehicle-vehicle-predicate',
    // Vehicle quick view
    FETCH_TRIP_UPDATE_SNAPSHOT: 'fetch-trip-update-snapshot',
    // Map
    UPDATE_HOVERED_ENTITY_KEY: 'update-hovered-entity-key',
    UPDATE_MAP_DETAILS: 'update-map-details',
    // TomTom Layers
    UPDATE_SHOW_INCIDENTS: 'update-show-incidents',
    UPDATE_SELECTED_INCIDENT_FILTERS: 'update-selected-incident-filters',
    UPDATE_SELECTED_CONGESTION_FILTERS: 'update-selected-congestion-filters',
    UPDATE_SHOW_ROUTE_ALERTS: 'update-show-route-alerts',
    UPDATE_SHOW_ALL_ROUTE_ALERTS: 'update-show-all-route-alerts',
    UPDATE_SELECTED_ROUTE_ALERTS: 'update-selected-route-alerts',
    UPDATE_SHOW_DISRUPTIONS: 'update-show-disruptions',
    UPDATE_SELECTED_DISRUPTION_FILTERS: 'update-selected-disruption-filters',
    // Roadworks Layers
    RESET_SHOW_ROADWORKS: 'reset-show-roadworks',
    UPDATE_SHOW_ROADWORKS: 'update-show-roadworks',
    UPDATE_SELECTED_ROADWORKS_FILTERS: 'update-selected-roadworks-filters',
    UPDATE_ROADWORKS_CALLED_API: 'update-roadworks-called-api',
    UPDATE_SELECTED_CARS: 'update-selected-cars',
    UPDATE_SELECTED_TMP_IMPACTS: 'update-selected-tmp-impacts',
    // navigation
    UPDATE_MAIN_VIEW: 'update-main-view',
    TOGGLE_RT_SIDE_PANEL: 'toggle-rt-side-panel',
    RESET_RT_SIDE_PANEL: 'reset-rt-side-panel',
    UPDATE_SECONDARY_PANEL_VIEW: 'update-secondary-panel-view',
    UPDATE_QUERY_PARAMS: 'update-query-params',
    // Blocks
    FETCH_CONTROL_BLOCKS: 'fetch-control-blocks',
    FETCH_CONTROL_VEHICLE_ALLOCATIONS: 'fetch-control-vehicle-allocations',
    UPDATE_CONTROL_VEHICLE_ALLOCATIONS: 'update-control-vehicle-allocations',
    UPDATE_CONTROL_BLOCKS_SORTING_PARAMS: 'update-control-blocks-sorting-params',
    UPDATE_CONTROL_BLOCKS_ACTIVE_BLOCK: 'update-control-blocks-active-block',
    CLEAR_CONTROL_BLOCKS_ACTIVE_BLOCK: 'clear-control-blocks-active-block',
    UPDATE_FOCUSED_BLOCK: 'update-focused-block',

    UPDATE_CONTROL_BLOCKS_ACTIVE_TRIP: 'update-control-blocks-active-trip',
    UPDATE_CONTROL_BLOCKS_LOADING: 'update-control-blocks-loading',
    UPDATE_CONTROL_BLOCKS_ACTIVE_BLOCK_LOADING: 'update-control-blocks-active-block-loading',
    UPDATE_CONTROL_BLOCK_SEARCH_RESULTS: 'update-control-block-search-results',
    UPDATE_BLOCKS_PERMISSIONS: 'update-blocks-permissions',
    // Stop Messaging
    FETCH_CONTROL_STOP_MESSAGES: 'fetch-control-stop-messages',
    UPDATE_CONTROL_STOP_MESSAGES_LOADING: 'update-control-stop-messages-loading',
    FETCH_CONTROL_STOP_GROUPS: 'fetch-control-stop-groups',
    UPDATE_CONTROL_STOP_GROUPS_LOADING: 'update-control-stop-groups-loading',
    UPDATE_STOP_MESSAGES_PERMISSIONS: 'update-stop-messages-permissions',
    TOGGLE_STOP_MESSAGES_MODAL: 'toggle-stop-messages-modal',
    // VEHICLE_ALLOCATION
    UPDATE_VEHICLE_SEARCH_RESULTS: 'update-search-vehicle-results',
    UPDATE_SEARCH_VEHICLE_SELECTED: 'update-search-vehicle-selected',
    SEARCH_VEHICLE_LOADING: 'search-vehicle-loading',
    CLEAR_SEARCH_VEHICLE_RESULTS: 'clear-search-vehicle-results',
    // Control
    UPDATE_CONTROL_DETAIL_VIEW: 'update-control-detail-view',
    UPDATE_ACTIVE_CONTROL_ENTITY_ID: 'update-active-control-entity-id',
    // Control: agencies
    FETCH_CONTROL_AGENCIES: 'fetch-control-agencies',
    // Control: routes
    FETCH_CONTROL_ROUTES: 'fetch-control-routes',
    CLEAR_CONTROL_ROUTES: 'clear-control-routes',
    UPDATE_CONTROL_ROUTES_LOADING: 'update-control-routes-loading',
    UPDATE_CONTROL_ACTIVE_ROUTE: 'update-control-active-route',
    UPDATE_CONTROL_ROUTES_SEARCH_RESULTS: 'update-control-routes-search-results',
    // Control: recurring cancellations
    FETCH_RECURRING_CANCELLATIONS: 'fetch-recurring-cancellations',
    FETCH_RECURRING_CANCELLATIONS_PERMISSIONS: 'fetch-recurring-cancellations-permissions',
    UPDATE_CONTROL_RECURRING_CANCELLATIONS_DATAGRID_CONFIG: 'update-control-recurring-cancellations-datagrid-config',
    UPDATE_CONTROL_RECURRING_CANCELLATIONS_LOADING: 'update-control-recurring-cancellations-loading',
    UPDATE_CONTROL_RECURRING_CANCELLATIONS_IS_LOADING: 'update-control-recurring-cancellations-is-loading',
    UPDATE_CONTROL_RECURRING_CANCELLATIONS_MESSAGE: 'update-control-recurring-cancellations-message',
    CLEAR_CONTROL_RECURRING_CANCELLATIONS_MESSAGE: 'clear-control-recurring-cancellations-message',
    CLEAR_CONTROL_RECURRING_CANCELLATIONS_VALIDATION: 'clear-control-recurring-cancellations-validation',
    UPDATE_CONTROL_RECURRING_CANCELLATIONS_REDIRECTION: 'update-control-recurring-cancellations-redirection',
    UPDATE_CONTROL_RECURRING_CANCELLATIONS_DISPLAY_OPERATOR_ERROR: 'update-control-recurring-cancellations-display-operator-error',
    // Control: route variants
    UPDATE_CONTROL_ROUTE_VARIANTS: 'update-control-route-variants',
    CLEAR_CONTROL_ROUTE_VARIANTS: 'clear-control-route-variants',
    UPDATE_CONTROL_ROUTE_VARIANTS_LOADING: 'update-control-route-variants-loading',
    UPDATE_CONTROL_ACTIVE_ROUTE_VARIANT: 'update-control-active-route-variant',
    UPDATE_CONTROL_ROUTE_VARIANTS_SEARCH_RESULTS: 'update-control-route-variants-search-results',
    // Control: filters
    MERGE_CONTROL_ROUTES_FILTERS: 'merge-control-routes-filters',
    RESET_CONTROL_ROUTES_SORTING: 'reset-control-routes-sorting',
    // Control: tripInstances
    FETCH_CONTROL_TRIP_INSTANCES: 'fetch-control-trip-instances',
    CLEAR_CONTROL_TRIP_INSTANCES: 'clear-control-trip-instances',
    UPDATE_CONTROL_TRIP_INSTANCES_LOADING: 'update-control-trip-instances-loading',
    UPDATE_CONTROL_TRIP_INSTANCES_UPDATING: 'update-control-trip-instances-updating',
    UPDATE_CONTROL_TRIP_INSTANCE_ENTRY: 'update_control_trip_instance_entry',
    SET_TRIP_INSTANCE_ACTION_RESULT: 'set_trip_instance_action_result',
    CLEAR_TRIP_INSTANCE_ACTION_RESULT: 'clear_trip_instance_action_result',
    UPDATE_TRIP_INSTANCE_ACTION_LOADING: 'update_trip_instance_action_loading',
    UPDATE_CONTROL_ACTIVE_TRIP_INSTANCE: 'update-control-active-trip-instance',
    UPDATE_CONTROL_ACTIVE_TRIP_INSTANCES: 'update-control-active-trip-instances',
    ADD_CONTROL_TRIP_INSTANCE_ENTRY: 'add-control-active-trip-instance',
    SELECT_CONTROL_SINGLE_TRIP: 'select-control-single-trip',
    SELECT_CONTROL_TRIPS: 'select-control-trips',
    SELECT_CONTROL_ALL_TRIPS: 'select-control-all-trips',
    DESELECT_CONTROL_ALL_TRIPS: 'deselect-control-all-trips',
    UPDATE_CONTROL_SELECTED_TRIPS: 'update-control-selected-trips',
    SELECT_CONTROL_SINGLE_STOP: 'select-control-single-stop',
    DESELECT_CONTROL_ALL_STOPS_BY_TRIP: 'deselect-control-all-stops-by-trip',
    UPDATE_CONTROL_SELECTED_STOPS_BY_TRIP: 'update-control-selected-stops-by-trip',
    UPDATE_CONTROL_SELECTED_STOPS_UPDATING: 'update-control-selected-stops-updating',
    CLEAR_CONTROL_SELECTED_STOPS: 'clear-control-selected-stops',
    SET_TRIP_STATUS_MODAL_ORIGIN: 'set-trip-status-modal-origin',
    UPDATE_CONTROL_TRIP_INSTANCES_LAST_FILTER: 'update-trip-instances-last-filter',
    UPDATE_CONTROL_TRIP_INSTANCES_TOTAL_COUNT: 'update-trip-instances-total-count',
    UPDATE_CONTROL_TRIP_INSTANCES_PERMISSIONS: 'update-control-trip-instances-permissions',

    // Control: tripInstance: AddTrip
    OPEN_ADD_TRIP_MODAL: 'open-add-trip-modal',
    UPDATE_CONTROL_TRIP_INSTANCES_ADD_TRIP_DATAGRID_CONFIG: 'update-trip-instances-add-trip-datagrid-config',
    UPDATE_CONTROL_TRIP_INSTANCES_SELECTED_ADD_TRIP: 'update-trip-instances-selected-add-trip',
    UPDATE_CONTROL_TRIP_INSTANCES_RESET_ADD_TRIP_STATE: 'update-trip-instances-reset-add-trip-step',
    SET_ADD_TRIP_MODAL_STATUS: 'set-add-trip-modal-status',
    UPDATE_ADD_TRIP_ACTION_REQUESTING: 'update-add-trip-action-requesting',
    UPDATE_ADD_TRIP_ACTION_RESULT: 'update-add-trip-action-result',
    UPDATE_IS_NEW_TRIP_DETAILS_FORM_EMPTY: 'update-is-new-trip-details-form-empty',
    BULK_UPDATE_TRIP_STOPS_ACTION_REQUESTING: 'bulk-update-trip-stops-action-requesting',
    BULK_UPDATE_TRIP_STOPS_ACTION_RESULT: 'bulk-update-trip-stops-action-result',

    // Control: Cross Link
    UPDATE_TRIP_CROSS_LINK: 'update-trip-cross-link',
    CLEAR_TRIP_CROSS_LINK: 'clear-trip-cross-link',
    // Control: Service date
    UPDATE_SERVICE_DATE: 'update-service-date',
    // User
    UPDATE_USER_PROFILE: 'update-user-profile',
    UPDATE_USER_BLOCKS_PERMISSIONS: 'update-user-blocks-permissions',
    UPDATE_USER_ROUTES_PERMISSIONS: 'update-user-routes-permissions',
    // Fleets:
    FETCH_CONTROL_FLEETS: 'fetch-control-fleets',
    UPDATE_CONTROL_FLEETS_DATAGRID_CONFIG: 'update-control-fleets-datagrid-config',

    // Alerts:
    FETCH_CONTROL_ALERTS: 'fetch-control-alerts',
    UPDATE_CONTROL_ALERTS_ROUTES: 'update-control-alerts-routes',
    UPDATE_CONTROL_ALERTS_FILTERS: 'update-alerts-filters',
    UPDATE_CONTROL_ALERTS_ROUTES_SEARCH_RESULTS: 'update-control-alerts-search-results',
    UPDATE_USER_PERMISSIONS: 'update-user-permissions',
    LOAD_CONTROL_ALERTS_DATAGRID_FILTER_MODEL: 'load-control-alerts-datagrid-filter-model',
    UPDATE_CONTROL_ALERTS_DATAGRID_FILTER_MODEL: 'update-control-alerts-datagrid-filter-model',
    UPDATE_CONTROL_ALERTS_DATAGRID_CONFIG: 'update-control-alerts-datagrid-config',

    // Disruptions
    FETCH_CONTROL_DISRUPTIONS: 'fetch-control-disruptions',
    UPDATE_CONTROL_DISRUPTIONS_PERMISSIONS: 'update-control-disruptions-permissions',
    UPDATE_CONTROL_DISRUPTIONS_LOADING: 'update-control-disruptions-loading',
    UPDATE_CONTROL_DISRUPTIONS_LOADING_STOPS_BY_ROUTE: 'update-control-disruptions-loading-stops-by-route',
    UPDATE_CONTROL_DISRUPTIONS_LOADING_ROUTES_BY_STOP: 'update-control-disruptions-loading-routes-by-stop',
    UPDATE_CONTROL_DISRUPTION_ACTION_REQUESTING: 'update-control-disruption-action-requesting',
    UPDATE_CONTROL_DISRUPTION_ACTION_RESULT: 'update-control-disruption-action-result',
    UPDATE_CONTROL_ACTIVE_DISRUPTION_ID: 'update-control-active-disruption-id',
    UPDATE_DISRUPTIONS_REVERSE_GEOCODE_LOADING_STATE: 'update-disruptions-reverse-geocode-loading-state',
    UPDATE_DISRUPTIONS_ROUTES_LOADING_STATE: 'update-disruptions-routes-loading-state',
    UPDATE_SELECTED_ROUTES: 'update-selected-routes',
    SHOW_SELECTED_ROUTES: 'show-selected-routes',
    COPY_DISRUPTION: 'copy-disruptions',
    OPEN_CREATE_DISRUPTIONS: 'open-create-disruptions',
    OPEN_COPY_DISRUPTIONS: 'open-copy-disruptions',
    UPDATE_AFFECTED_ENTITIES: 'update-affected-entities',
    UPDATE_CACHED_SHAPES: 'update-cached-shapes',
    UPDATE_CACHED_ROUTES_TO_STOPS: 'update-cached-routes-to-stops',
    UPDATE_CACHED_STOPS_TO_ROUTES: 'update-cached-stops-to-routes',
    DELETE_AFFECTED_ENTITIES: 'delete-affected-entities',
    SET_DISRUPTIONS_MODAL_STATUS: 'set-disruption-modal-status',
    UPDATE_CURRENT_STEP: 'update-current-step',
    UPDATE_STOPS_BY_ROUTE: 'update-stops-by-route',
    UPDATE_ROUTES_BY_STOP: 'update-routes-by-stop',
    RESET_STATE: 'reset_state',
    UPDATE_EDIT_MODE: 'update-edit-mode',
    UPDATE_DISRUPTION_TO_EDIT: 'update-disruption-to-edit',
    UPDATE_DISRUPTION_FILTERS: 'update-disruption-filters',
    UPDATE_DISRUPTION_DATAGRID_CONFIG: 'update-disruption-datagrid-config',
    UPDATE_IS_DISRUPTION_FORM_MODIFIED: 'update-is-disruption-form-modified',
    UPDATE_DIVERSION_EDIT_MODE: 'update-diversion-edit-mode',
    UPDATE_DIVERSION_TO_EDIT: 'update-diversion-to-edit',
    OPEN_DIVERSION_MANAGER: 'open-diversion-manager',
    SET_DIVERSION_MANAGER_READY: 'set-diversion-manager-ready',
    ADD_DIVERSION: 'add-diversion',
    UPDATE_DIVERSION_RESULT_STATE: 'update-diversion-result-state',

    // Incidents
    FETCH_CONTROL_INCIDENTS_DISRUPTIONS: 'fetch-control-incidents-disruptions',
    FETCH_CONTROL_INCIDENTS: 'fetch-control-incidents',
    UPDATE_CONTROL_INCIDENTS_PERMISSIONS: 'update-control-incidents-permissions',
    UPDATE_CONTROL_INCIDENTS_LOADING: 'update-control-incidents-loading',
    UPDATE_CONTROL_INCIDENTS_LOADING_STOPS_BY_ROUTE: 'update-control-incidents-loading-stops-by-route',
    UPDATE_CONTROL_INCIDENTS_LOADING_ROUTES_BY_STOP: 'update-control-incidents-loading-routes-by-stop',
    UPDATE_CONTROL_INCIDENT_FOR_EDIT_LOADING: 'update-control-incident-for-edit-loading',
    UPDATE_CONTROL_INCIDENTS_SORTING_PARAMS: 'update-control-incidents-sorting-params',
    UPDATE_CONTROL_INCIDENT_ACTION_REQUESTING: 'update-control-incident-action-requesting',
    UPDATE_CONTROL_INCIDENT_ACTION_RESULT: 'update-control-incident-action-result',
    UPDATE_CONTROL_ACTIVE_INCIDENT_ID: 'update-control-active-incident-id',
    UPDATE_CONTROL_ACTIVE_INCIDENT_DISRUPTION_ID: 'update-control-active-incident-disruption-id',
    UPDATE_CONTROL_ACTIVE_INCIDENT: 'update-control-active-incident',
    UPDATE_CONTROL_SET_ALL_INCIDENTS: 'update-control-set-all-incidents',
    UPDATE_CONTROL_SET_ALL_INCIDENTS_DISRUPTIONS: 'update-control-set-all-incidents-disruptions',
    UPDATE_INCIDENTS_REVERSE_GEOCODE_LOADING_STATE: 'update-incident-reverse-geocode-loading-state',
    UPDATE_INCIDENTS_ROUTES_LOADING_STATE: 'update-incident-routes-loading-state',
    UPDATE_INCIDENT_SELECTED_ROUTES: 'update-incident-selected-routes',
    SHOW_INCIDENT_SELECTED_ROUTES: 'show-incident-selected-routes',
    COPY_INCIDENT: 'copy-incidents',
    OPEN_CREATE_INCIDENTS: 'open-create-incidents',
    OPEN_COPY_INCIDENTS: 'open-copy-incidents',
    UPDATE_INCIDENT_AFFECTED_ENTITIES: 'update-incident-affected-entities',
    UPDATE_INCIDENT_CACHED_SHAPES: 'update-incident-cached-shapes',
    UPDATE_INCIDENT_CACHED_ROUTES_TO_STOPS: 'update-incident-cached-routes-to-stops',
    UPDATE_INCIDENT_CACHED_STOPS_TO_ROUTES: 'update-incident-cached-stops-to-routes',
    DELETE_INCIDENT_AFFECTED_ENTITIES: 'delete-incident-affected-entities',
    SET_INCIDENTS_MODAL_STATUS: 'set-incident-modal-status',
    UPDATE_INCIDENT_CURRENT_STEP: 'update-incident-current-step',
    UPDATE_INCIDENT_STOPS_BY_ROUTE: 'update-incident-stops-by-route',
    UPDATE_INCIDENT_ROUTES_BY_STOP: 'update-incident-routes-by-stop',
    RESET_INCIDENT_STATE: 'reset-incident-state',
    UPDATE_INCIDENT_EDIT_MODE: 'update-incident-edit-mode',
    UPDATE_INCIDENT_TO_EDIT: 'update-incident-to-edit',
    UPDATE_INCIDENT_FILTERS: 'update-incident-filters',
    UPDATE_INCIDENT_DATAGRID_CONFIG: 'update-incident-datagrid-config',
    SET_WORKAROUND_PANEL_STATUS: 'set-workaround-panel-status',
    SET_EDIT_EFFECT_PANEL_STATUS: 'set-edit-effect-panel-status',
    UPDATE_DISRUPTION_KEY_TO_WORKAROUND_EDIT: 'update-disruption-key-to-workaround-edit',
    UPDATE_DISRUPTION_KEY_TO_EDIT_EFFECT: 'update-disruption-key-to-edit-effect',
    UPDATE_EFFECT_REQUIRES_TO_UPDATE_NOTES: 'update-control-effect-requires-to-update-notes',
    UPDATE_WORKAROUNDS_NEED_TO_BE_UPDATED: 'update-control-workarounds-need-to-be-updated',
    SET_DISRUPTION_FOR_WORKAROUND_EDIT: 'set-disruption-for-workaround-edit',
    SET_REQUEST_TO_UPDATE_EDIT_EFFECT: 'set-request-to-update-edit-effect',
    SET_REQUESTED_DISRUPTION_KEY_TO_UPDATE_EDIT_EFFECT: 'set-requested-disruption-key-to-update-edit-effect',
    UPDATE_MAP_DRAWING_ENTITIES: 'update-map-drawing-entities',
    // UPDATE_INCIDENT_DIVERSION_EDIT_MODE: 'update-incident-diversion-edit-mode',
    // OPEN_INCIDENT_CREATE_DIVERSION: 'open-incident-create-diversion',
    // ADD_INCIDENT_DIVERSION: 'add-incident-diversion',
    // UPDATE_INCIDENT_DIVERSION_CREATION_STATE: 'update-incident-diversion-creation-state',

    // TripReplays
    UPDATE_CONTROL_TRIP_REPLAYS_LOADING: 'update-control-trip-replays-loading',
    UPDATE_CONTROL_TRIP_REPLAYS_CURRENT_TRIP_DETAIL: 'update-control-trip-replays-current-trip-detail',
    CLEAR_CONTROL_TRIP_REPLAY_CURRENT_TRIP: 'clear-control-trip-replay-current-trip',
    UPDATE_CONTROL_TRIP_REPLAYS_FILTER_DATA: 'update-control-trip-replay-filter-data',
    UPDATE_CONTROL_TRIP_REPLAYS_SEARCH_TERM: 'update-control-trip-replay-search-term',
    RESET_CONTROL_TRIP_REPLAYS_SEARCH_TERM: 'reset-control-trip-replay-search-term',
    UPDATE_CONTROL_TRIP_REPLAYS_SEARCH_DATE: 'update-control-trip-replay-search-date',
    UPDATE_CONTROL_TRIP_REPLAYS_START_TIME: 'update-control-trip-replay-start-time',
    UPDATE_CONTROL_TRIP_REPLAYS_END_TIME: 'update-control-trip-replay-end-time',
    UPDATE_CONTROL_TRIP_REPLAYS_TIME_TYPE: 'update-control-trip-replay-time-type',
    UPDATE_CONTROL_TRIP_REPLAYS_DISPLAY_FILTERS: 'update-control-trip-replay-display-filters',
    UPDATE_CONTROL_TRIP_REPLAYS_CLEAR_DATE: 'update-control-trip-replay-clear-date',
    FETCH_CONTROL_TRIP_REPLAYS_TRIPS: 'update-control-trip-replay-trips',
    CLEAR_CONTROL_TRIP_REPLAYS_TRIPS: 'clear-control-trip-replay-trips',
    DISPLAY_CONTROL_TRIP_REPLAYS_SINGLE_TRIP: 'display-control-trip-replays-single-trip',
    REDIRECT_CONTROL_TRIP_REPLAYS: 'redirect-control-trip-replays',
    UPDATE_CONTROL_TRIP_REPLAYS_PREVIOUS_FILTER_VALUES: 'update-control-trip-replays-previous-filter-values',
    UPDATE_CONTROL_TRIP_REPLAYS_PREVIOUS_TRIP_DETAIL: 'update-control-trip-replays-previous-trip-detail',
    // VehicleReplays
    FETCH_CONTROL_VEHICLE_REPLAYS: 'update-control-vehicle-replay',
    CLEAR_CONTROL_VEHICLE_REPLAYS_CURRENT_REPLAY_DETAIL: 'clear-control-vehicle-replays-current-replay-detail',
    UPDATE_CONTROL_VEHICLE_REPLAYS_EVENTS: 'update-control-vehicle-replays-events',
    UPDATE_CONTROL_VEHICLE_FIRST_REPLAY_EVENT: 'update-control-vehicle-first-replay-event',
    UPDATE_SPLIT_CONTROL_VEHICLE_REPLAYS_EVENTS: 'update-split-control-vehicle-replays-events',
    UPDATE_VEHICLE_VIEW_TAB_STATUS: 'update-vehicle-view-tab-status',
    // Analytics
    SET_ID_MAPPINGS: 'set-id-mappings',
    SET_OCCUPANCY: 'set-occupancy',
    SET_OCCUPANCY_FILTERS: 'set-occupancy-filters',
    SET_OCCUPANCY_AGENCY_FILTERS: 'set-occupancy-agency-filters',
    SET_OCCUPANCY_ROUTES_FILTERS: 'set-occupancy-routes-filters',
    OCCUPANCY_IS_LOADING: 'occupancy-is-loading',
    // Data Management
    UPDATE_CONTROL_DATAMANAGEMENT_PAGESETTINGS: 'update-control-data-management-pagesettings',
    // Application Settings
    UPDATE_APP_SETTINGS: 'update-application-settings',
    // Notifications
    FETCH_CONTROL_NOTIFICATIONS: 'fetch-control-notificaions',
    UPDATE_CONTROL_NOTIFICATIONS_DATAGRID_CONFIG: 'update-control-notifications-datagrid-config',
    UPDATE_CONTROL_NOTIFICATIONS_FILTER_COUNT: 'update-control-notifications-filter-count',
    UPDATE_CONTROL_NOTIFICATIONS_LAST_FILTER: 'update-control-notifications-last-filter',
    UPDATE_CONTROL_NOTIFICATIONS_PERMISSIONS: 'update-control-notifications-permissions',
    UPDATE_CONTROL_NOTIFICATION_ACTION_REQUESTING: 'update-control-notification-action-requesting',
    UPDATE_CONTROL_NOTIFICATION_ACTION_RESULT: 'update-control-notification-action-result',
    UPDATE_CONTROL_NOTIFICATION_SELECTED: 'update-control-notification-selected',

    // Datagrid Config
    UPDATE_ROUTES_TRIPS_DATAGRID_CONFIG: 'update-routes-trips-datagrid-config',
    UPDATE_DEFAULT_ROUTES_TRIPS_DATAGRID_CONFIG: 'update-default-routes-trips-datagrid-config',

    // Bus Priority
    FETCH_CONTROL_BUS_PRIORITY_ROUTES: 'fetch-control-bus-priority-routes',
    UPDATE_CONTROL_BUS_PRIORITY_ROUTES_LOADING: 'update-control-bus-priority-routes-loading',
    UPDATE_CONTROL_BUS_PRIORITY_ROUTES_DATAGRID_CONFIG: 'update-control-bus-priority-routes-datagrid-config',
    FETCH_CONTROL_BUS_PRIORITY_INTERSECTIONS: 'fetch-control-bus-priority-intersections',
    UPDATE_CONTROL_BUS_PRIORITY_INTERSECTIONS_LOADING: 'update-control-bus-priority-intersections-loading',
    UPDATE_CONTROL_BUS_PRIORITY_INTERSECTIONS_DATAGRID_CONFIG: 'update-control-bus-priority-intersections-datagrid-config',
    UPDATE_CONTROL_BUS_PRIORITY_THRESHOLDS_LOADING: 'update-control-bus-priority-thresholds-loading',
    FETCH_CONTROL_BUS_PRIORITY_THRESHOLDS: 'fetch-control-bus-priority-thresholds',
    UPDATE_CONTROL_BUS_PRIORITY_THRESHOLDS_DATAGRID_CONFIG: 'update-control-bus-priority-thresholds-datagrid-config',
    UPDATE_CONTROL_BUS_PRIORITY_PERMISSIONS: 'update-control-bus-priority-permissions',
};
